// Centralised date formatting for the whole app.
// Displayed dates use DD/MM/YYYY. Date-picker <input type="date"> values must
// stay in ISO (YYYY-MM-DD) and should NOT use these helpers.

const pad = (n) => String(n).padStart(2, "0");

// Format a date (ISO string, "YYYY-MM-DD", or Date) as DD/MM/YYYY.
export function formatDate(value, fallback = "—") {
  if (!value) return fallback;
  let d;
  if (value instanceof Date) {
    d = value;
  } else {
    const s = String(value);
    // Plain date part (no time) -> parse as local to avoid TZ shifting the day.
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return `${m[3]}/${m[2]}/${m[1]}`;
    d = new Date(s);
  }
  if (Number.isNaN(d.getTime())) return fallback;
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

// DD/MM/YYYY HH:mm for timestamps.
export function formatDateTime(value, fallback = "—") {
  if (!value) return fallback;
  const d = value instanceof Date ? value : new Date(String(value));
  if (Number.isNaN(d.getTime())) return fallback;
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// --- Delivery weekday helpers (0=Mon … 6=Sun) ---
const WEEKDAY_SHORT = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

// JS Date.getDay(): 0=Sun..6=Sat -> convert to our 0=Mon..6=Sun.
function isoWeekday(d) {
  return (d.getDay() + 6) % 7;
}

// Parse a "YYYY-MM-DD" string as a local date (no TZ shift).
function parseLocal(dateStr) {
  const m = String(dateStr).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const d = new Date(String(dateStr));
  return Number.isNaN(d.getTime()) ? null : d;
}

export function isAllowedWeekday(dateStr, days) {
  if (!dateStr || !Array.isArray(days) || days.length === 0) return true;
  const d = parseLocal(dateStr);
  if (!d) return false;
  return days.includes(isoWeekday(d));
}

// Next date (YYYY-MM-DD) on/after `fromStr` whose weekday is allowed.
export function nextAllowedDate(days, fromStr) {
  const start = fromStr ? parseLocal(fromStr) : new Date();
  const allowed = Array.isArray(days) && days.length ? days : [0, 1, 2, 3, 4];
  const d = start || new Date();
  for (let i = 0; i < 14; i++) {
    if (allowed.includes(isoWeekday(d))) break;
    d.setDate(d.getDate() + 1);
  }
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function weekdayNames(days) {
  if (!Array.isArray(days) || days.length === 0) return WEEKDAY_SHORT.join(", ");
  return [...days].sort((a, b) => a - b).map((d) => WEEKDAY_SHORT[d]).join(", ");
}
